export const siteSettings = {
  name: "Top Tier Market",
  link: "https://toptiermarket.net",
  email: "support@toptiermarket.net",
  appLink: "https://app.toptiermarket.net",
};
